// extracted by mini-css-extract-plugin
export default {"main":"_1f252e240f","tit":"_513fdb7088","maintitle":"a04a9bb482","ylw":"_2ae8817eac","white":"e6a44d6d18","mv_title":"_92dcad5dd8","mv_nc":"_5f5b3cccd5","mv_in":"c608f5ba61"};